import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { IconButton } from "../../../action/IconButton/IconButton.js";
import "../../../action/Button/Button.js";
import "../../../action/Badge/BadgeButton.js";
import "../../../action/Badge/BadgeRadio.js";
import "../../../action/Badge/BadgeCheckbox.js";
import { useModalContext } from "./hooks/useModalContext.js";
import { s as styles } from "../../../../chunks/Modal.module-DVI2zRnB.js";
const ModalHeader = ({
  closeButtonDescription,
  children,
  headingLevel = "h1",
  className,
  ...props
}) => {
  const { isDismissable, onClose } = useModalContext();
  return /* @__PURE__ */ jsxs("header", { className: clsx(styles.modalHeader, className), ...props, children: [
    typeof children === "string" ? /* @__PURE__ */ jsx(Text, { component: headingLevel, variant: "heading-small", children }) : children,
    isDismissable && /* @__PURE__ */ jsx(IconButton, { variant: "ghost", onPress: onClose, "aria-label": closeButtonDescription })
  ] });
};
export {
  ModalHeader
};
